module.exports = __webpack_public_path__ + "img/experirence-icon1.8a01238f.png";